import AddIcon from "@mui/icons-material/Add";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import { Button, InputAdornment, Stack, TextField } from "@mui/material";
import type { ReactNode } from "react";

interface Props {
  searchValue: string;
  // eslint-disable-next-line no-unused-vars
  onSearchChange(value: string): void;
  onCreate(): void;
  createLabel: string;
  onImport?(): void;
  importLabel?: string;
  showImport?: boolean;
  leftExtra?: ReactNode;
  rightExtra?: ReactNode;
}

export default function CrmTableToolbar({
  searchValue,
  onSearchChange,
  onCreate,
  createLabel,
  onImport,
  importLabel = "Import Data",
  showImport = true,
  leftExtra,
  rightExtra,
}: Props) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{ p: 2 }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <TextField
          size="small"
          placeholder="Search"
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          sx={{ width: 300 }}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <SearchSharpIcon sx={{ color: "#8E95A2", fontSize: 20 }} />
                </InputAdornment>
              ),
            },
          }}
        />
        {leftExtra}
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center">
        {rightExtra}
        {showImport && (
          <Button
            variant="contained"
            startIcon={<SystemUpdateAltIcon />}
            onClick={onImport}
            sx={{
              height: 40,
              borderRadius: "96px",
              px: 3,
              backgroundColor: "#454545",
              boxShadow: "none",
              textTransform: "none",
              "&:hover": { backgroundColor: "#353535", boxShadow: "none" },
            }}
          >
            {importLabel}
          </Button>
        )}
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreate}
          sx={{
            height: 40,
            borderRadius: "96px",
            px: 3,
            backgroundColor: "#111111",
            boxShadow:
              "0px 1px 5px rgba(0,0,0,0.12), 0px 2px 2px rgba(0,0,0,0.14), 0px 3px 1px rgba(0,0,0,0.2)",
            textTransform: "none",
            "&:hover": { backgroundColor: "#000000" },
          }}
        >
          {createLabel}
        </Button>
      </Stack>
    </Stack>
  );
}
